import { GenericStructValue, GenericCallCard, GenericEventCard } from './chunk-2H3ENTSI.js';
import { SUSHISWAP, SUSHISWAP_COMPONENTS, SUSHISWAP_EVENTS, SUSHISWAP_CALLS, SUSHISWAP_KINDS } from './chunk-IFYJS34L.js';

// src/protocols/sushiswap/index.ts
var PID = SUSHISWAP.protocolId;
var C = SUSHISWAP_COMPONENTS;
var value = (kind, component) => ({
  protocolId: PID,
  kind,
  component,
  fields: []
});
var call = (name, component) => ({
  protocolId: PID,
  call: name,
  component,
  summaryFields: []
});
var event = (name, component) => ({
  protocolId: PID,
  event: name,
  component,
  summaryFields: []
});
var SUSHISWAP_HINTS = {
  valueHints: [value(SUSHISWAP_KINDS.routeProcessorData, C.routeProcessorData)],
  callHints: [call(SUSHISWAP_CALLS.snwapMultiple, C.snwapMultiple)],
  eventHints: [
    event(SUSHISWAP_EVENTS.route, C.route),
    event(SUSHISWAP_EVENTS.swapAndBridgeOnSource, C.bridgeOnSource)
  ]
};
function registerSushiSwap(registry) {
  registry.registerValue(C.routeProcessorData, GenericStructValue);
  registry.registerCall(C.snwapMultiple, GenericCallCard);
  registry.registerEvent(C.route, GenericEventCard);
  registry.registerEvent(C.bridgeOnSource, GenericEventCard);
  registry.registerHints(SUSHISWAP_HINTS);
  return registry;
}

export { SUSHISWAP_HINTS, registerSushiSwap };
//# sourceMappingURL=chunk-FH7FLM7O.js.map
//# sourceMappingURL=chunk-FH7FLM7O.js.map